import ShareableLinkViewers from './ShareableLinkViewers.component';

export default ShareableLinkViewers;